import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';

interface VideoCardProps {
  src: string;
  allowFullScreen?: boolean;
  height?: number;
  width?: number;
  aspectRatio?: string;
}

export default function VideoCard({
  src,
  allowFullScreen = true,
  height,
  width,
  aspectRatio,
}: VideoCardProps) {
  return (
    <Card
      sx={{
        borderRadius: '8px',
        overflow: 'hidden',
        boxShadow: '0 0 4px 0 rgba(0, 0, 0, 0.25)',
      }}
    >
      <CardMedia
        key={src}
        component="iframe"
        src={src}
        allowFullScreen={allowFullScreen}
        sx={{
          width: '100%',
          maxWidth: width ? width : 1400,
          height: height ? height : 600,
          aspectRatio: aspectRatio ? aspectRatio : '9 / 5',
          border: 0,
          display: 'block',
        }}
      />
    </Card>
  );
}
